// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v3.3.1-1-g27aa4b10-dirty",
    "hash": "g27aa4b10",
    "distance": 1,
    "tag": "v3.3.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v3.3.1",
        "major": 3,
        "minor": 3,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "3.3.1"
    },
    "suffix": "1-g27aa4b10-dirty",
    "semverString": "3.3.1+1.g27aa4b10",
    "version": "3.3.1"
};
/* tslint:enable */
